import { Controller } from "@hotwired/stimulus"

/**
 * WelcomeHint Controller
 *
 * Displays a random hint from a pool passed via `hints` value.
 * Tracks seen hints in localStorage so the user sees no repeats
 * until all have been shown.
 */
export default class extends Controller {
  static targets = ["text"]
  static values = {
    userId: Number,
    hints: Array
  }

  connect() {
    this.storageKey = `omni_hints_seen_${this.userIdValue}`
    this.show(this.pickNext())
  }

  next() {
    const hint = this.pickNext()
    this.textTarget.style.opacity = "0"
    setTimeout(() => {
      this.show(hint)
      this.textTarget.style.opacity = "1"
    }, 180)
  }

  // ─── Private ───────────────────────────────────────────────

  show(hint) {
    this.textTarget.textContent = hint
    this.textTarget.style.opacity = "1"
  }

  pickNext() {
    const hints = this.hintsValue
    if (!hints.length) return ""

    let seen = this.loadSeen()

    if (seen.length >= hints.length) {
      seen = []
      this.saveSeen(seen)
    }

    const unseen = hints.filter((_, i) => !seen.includes(i))
    const picked = unseen[Math.floor(Math.random() * unseen.length)]
    seen.push(hints.indexOf(picked))
    this.saveSeen(seen)

    return picked
  }

  loadSeen() {
    try {
      const data = localStorage.getItem(this.storageKey)
      return data ? JSON.parse(data) : []
    } catch {
      return []
    }
  }

  saveSeen(seen) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(seen))
    } catch {
      // localStorage unavailable — no problem
    }
  }
}
